export default __webpack_public_path__ + "assets/images/a4c3cd22f6ae16c2100c564c07b98599.png";